import config from "@/config";
import questionaryInfoFields from "@/questionaryFieldsConfig";

export const getQuestionaryInfoFields = () => {
  return questionaryInfoFields.filter(i => (config.questionaryHiddenField as string[]).indexOf(i.name) === -1);
};

export const getEditableQuestionaryInfoFields = () => {
  return getQuestionaryInfoFields().filter(i => !i.fieldMeta?.adminOnly);
};
